import { answeredMapper, calidadDatosMapper, invalidMapper, porcRespuestasMapper } from "../dashHelper"
import { getCommonWidget } from '../dashWidgetHelper'
import { getLineDetailedRadar, radialMapperByIndicator } from "../widgetsLibrary/widgetsLine"
import { commonWidgets, getCmID, jacCustomerJourneyMapper, getJacCustomerJourney, postVentaMapperJacCustomerJourney,
         getJacCalidadDatosWidget, getJacPorcRespuestasWidget, getWorkflowsById } from "./commonWidgetsJac"

export default {
  title: "Demo Post postventa Dashboard",
  description: "Demo Post postventa Dashboard",
  backgroundClassName: (filters: any) => {
    return 'epsilon-hero-bg'
  },
  widgets: (filters: FiltersUI) => [
    getLineDetailedRadar({
      mainIndicator: 'Experiencia_CSI',
      radialIndicators: [
        'Experiencia_CSI',
        'Competencia_AS',
        'recepcion_CSI',
        'Avance_CSI',
        'entregapv',
        'Reparacion_CSI'
      ],
      radialType: 'byIndicator',
      size: [4, 3],
      title: 'widgets.snPostventa',
      //criticalMomentInclude: [getCmID('postventa')],
      extraConfigs: {
        backgroundColor: 'transparent',
        theme: 'dark',
        showRadialChart: true,
        initialVisibleChart: 1,
        groups: ['JAC', 'Zona 1 P', 'Zona 2 P', 'Zona 3 P', 'Zona 4 P', 'Zona 5 P'],
        maxValue: 100
      },
      groupByLevel: 2,
      useNormalizedRadial: true,
      indicatorsNames: {
        'Experiencia_CSI': 'Satisfacción',
        'Competencia_AS': 'Amabilidad',
        'recepcion_CSI': 'Calidad de recepción',
        'Avance_CSI': 'Información de avance en reparación',
        'entregapv': 'Proceso de entrega',
        'Reparacion_CSI': 'Tasa de retorno'
      },
      mainSort: { sortBy: 'group_0', value: 'asc' },
    }),
    //1
    {
      title: 'labels.surveys',
      type: 'label',
      size: [2, 1],
      config: { color: '#B7AADC' },
    },
    {
      title: 'labels.alerts',
      type: 'label',
      size: [2, 1],
      config: { color: '#B7AADC' },
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'surveyCountTrendByMonth',
      subTitle: 'widgets.surveyCountMonth',
      size: [1, 2],
      indicator: 'SURVEY_COUNT',
      //criticalMomentInclude: [getCmID('servicio')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'surveyCountTrendByWeek',
      subTitle: 'widgets.surveyCountWeek',
      size: [1, 2],
      indicator: 'SURVEY_COUNT',
      //criticalMomentInclude: [getCmID('servicio')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'alertsTrendByMonth',
      subTitle: 'widgets.alertsCountMonth',
      size: [1, 2],
      indicator: 'ALERT_FIRST_RESPONSE_TIME',
      //criticalMomentInclude: [getCmID('servicio')],
      extraConfigs: {
        useCurrent: 0,
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'alertsTrendByWeek',
      subTitle: 'widgets.alertsCountWeek',
      size: [1, 2],
      indicator: 'ALERT_FIRST_RESPONSE_TIME',
      //criticalMomentInclude: [getCmID('servicio')],
      extraConfigs: {
        useCurrent: 0,
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'multipleTrendByMonth',
      title: 'widgets.npsPostventa',
      size: [2, 2],
      indicator: 'recomendacionpv',
    }),

    getJacCalidadDatosWidget(filters?.criticalMoments[0]),
    getJacPorcRespuestasWidget(filters?.criticalMoments[0]),
  
    getJacCustomerJourney({
      id: 'multipleGaugeByQuestion',
      title: 'widgets.customerJourneyPostventa',
      helpText: '',
      size: [4, 2],
      mapper: postVentaMapperJacCustomerJourney,
      extraConfigs: {
        chartRadius: '80%',
        chartCenter: ['50%', '45%'],
        labelFontSize: 40,
        groupNameFormat: 'description',
        maxValue: 100,
        colors: undefined
      },
      indicators: [
        { name: 'Experiencia_CSI', formula: 'count-number' },
        { name: 'Competencia_AS', formula: 'count-number' },
        { name: 'recepcion_CSI', formula: 'count-number' },
        { name: 'Avance_CSI', formula: 'count-number' },
        { name: 'entregapv', formula: 'count-number' },
        { name: 'Reparacion_CSI', formula: 'count-number' },
      ],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByTagBest',
      title: 'widgets.bestRotativasPostventa',
      size: [2, 1],
      indicator: 'SENTIMENT',
      //criticalMomentInclude: [getCmID('servicio')],
      extras: {
        trunc: 'HALF_DOWN',
        topSize: 3,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByTagWorst',
      title: 'widgets.worstRotativasPostventa',
      size: [2, 1],
      indicator: 'SENTIMENT',
      //criticalMomentInclude: [getCmID('servicio')],
      extras: {
        resultType: 'bottom',
        trunc: 'HALF_UP',
        bottomSize: 3,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'mapByGeos',
      title: 'Mapa de estaciones',
      size: [2, 2],
      indicator: 'recomendacionpv',
      //criticalMomentInclude: [getCmID('servicio')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByGeoBest',
      title: 'widgets.bestGeoLocationsPostventa',
      size: [1, 2],
      extraConfigs: {
        backgroundColor: '#501C78',
        titleBackgroundColor: '#88DD76'
      },
      indicator: 'recomendacionpv',
      //criticalMomentInclude: [getCmID('servicio')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByGeoWorst',
      title: 'widgets.worstGeoLocationsPostventa',
      size: [1, 2],
      extraConfigs: {
        backgroundColor: '#501C78',
        titleBackgroundColor: '#db7476'
      },
      indicator: 'recomendacionpv',
      //criticalMomentInclude: [getCmID('servicio')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'wordCountWithLinks',
      title: 'widgets.wordCount',
      size: [4, 2],
      //criticalMomentInclude: [getCmID('servicio')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'diagramaIshikawa',
      title: 'widgets.ishikawa',
      size: [4, 2],
      indicator: 'SENTIMENT',
      //criticalMomentInclude: [getCmID('servicio')],
    }),

    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'textAnalysis',
      title: "widgets.sentimentAnalysis",
      size: [4, 3],
      indicator: 'SENTIMENT',
      //criticalMomentInclude: [getCmID('servicio')],
    })
  ],
} as DasboardConfig
